export enum PaymentStatus {
  Authorised = 'Authorised',
  Error = 'Error',
  Pending = 'Pending',
  PresentToShopper = 'PresentToShopper',
  Refused = 'Refused',
  Received = 'Received',
  InProgress = 'In Progress',
  Cancelled = 'Cancelled',
}
